import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppContainer from './config/AppContainer';
import { ContextProvider } from './config/providers/ContextProviders';

//animated
import "animate.css";
import "animate.css/animate.compat.css";

//react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ContextProvider>
        <AppContainer />
    </ContextProvider>
);
